<template>
    <button
        class="CircleIconButton"
        :class="{ 'CircleIconButton--disabled': disabled}"
        :disabled="disabled"
        @click="buttonClicked"
    >
        <span :class="icon" />
    </button>
</template>
<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        icon: {
            type: String,
            required: true
        }
    },
    methods: {
        buttonClicked() {
            this.$emit('buttonClicked');
        }
    }
};
</script>

<style lang="scss" scoped>
.CircleIconButton{
    width: 56px;
    height: 56px;
    border: none;
    border-radius: 50%;
    background-color: $color-f2m-pink;
    color: $color-white;
    font-size: 24px;
    cursor: pointer;
    box-shadow: 0px 4px 8px rgba(230, 0, 126, 0.3);

    &--disabled{
        cursor: default;
        opacity: .4;
    }
}
</style>
